module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/down_icon-652559c8395456b36627c9ef6faeb4ed.svg";